import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'db-custom-domain-table',
    templateUrl: './custom-domain-table.component.html',
    styleUrl: './custom-domain-table.component.scss',
    standalone: false
})
export class CustomDomainTableComponent {
  @Input() domain = 'yourbrand.com'
  @Input() pointed = false
  @Input() status = 'inactive'
  @Input() sslStatus = 'active'
  openTooltip = false;
  @Input() loading = false;
  @Output() openNameservers = new EventEmitter<void>()
  @Output() recheckStatus = new EventEmitter<void>()
  @Output() removeDomain = new EventEmitter<void>()

  onRemove() {
    this.removeDomain.emit();
    this.openTooltip = false;
  }

  checkStatus() {
    this.loading = true;
    this.recheckStatus.emit();
  }
}
